import { FormEvent, useEffect, useState } from 'react';
import { useGetAuftragMessagesMutation, useWriteAuftragMessageMutation } from '../../../api/AuftragAPI';
import { useWhoamiMutation } from '../../../api/LoginAPI';
import { IAuftragMessage, ProfileInfo } from '../../../types/Types';
import { formatToEuroDateTime } from '../../../util/DateUtils';
import MaxInputAnzahlComponent from '../../MaxInputAnzahlComponent';


interface ThisProps {
  //callback1?: (location: ILocation) => void; // Callback-Prop
  //statusChanged: () => void;
  //changeColor: (auftraguid: string, color: string) => void;
  //centerOnMap: (id: string) => void;
  auftragUid: string,
  refreshTrigger?: number,
}

/**
 * @author noone
 */
const AuftragMessageComponent: React.FC<ThisProps> = ({ auftragUid, refreshTrigger = 0 }) => {

  const [getMessages] = useGetAuftragMessagesMutation();
  const [writeMessage] = useWriteAuftragMessageMutation();
  const [whoamiAPI] = useWhoamiMutation();

  const [messages, setMessages] = useState<IAuftragMessage[]>([]);
  const [profileInfo, setProfileInfo] = useState<ProfileInfo>();

  const [messageText, setMessageText] = useState<string>("");

  const sendMessage = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    writeMessage({ uid: auftragUid, dto: { text: messageText } }).unwrap()
      .then(() => {
        setMessageText("");
        getMessages(auftragUid).unwrap().then((data) => {
          setMessages(data);
        }).catch((error) => console.log(error));
      })
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    whoamiAPI().unwrap()
      .then(setProfileInfo)
      .then(() => {
        getMessages(auftragUid).unwrap()
          .then((data) => setMessages(data))
          .catch((error) => console.log(error));
      })
      .catch((error) => console.log(error));

  }, [auftragUid, refreshTrigger]);

  return (
    <>

      <h3>Chat Liste</h3>

      <div>

        {messages?.map((e, index) => (
          <div key={index} style={{ display: 'flex', justifyContent: e.erstelltVonEmail === profileInfo?.email ? 'flex-end' : 'flex-start', marginBottom: '10px' }}>
            <div className={ 'rounded-lg p-3 ' + (e.isNew ? ' shadow-lg' : '')} style={{
              backgroundColor: e.erstelltVonEmail === profileInfo?.email ? '#dcf8c6' : '#f1f0f0',
              border: "2px solid " + (e.isNew ? '#76c08c' : '#ffffff'),
              maxWidth: '70%',
              wordWrap: 'break-word',
            }}>
              <div style={{ minWidth: '200px' }}>
                <div style={{ textAlign: 'left', marginBottom: '5px' }}>
                  <span style={{ fontSize: "8pt" }}>{e.erstelltVonEmail}</span>
                </div>
                {e.text}
                <div style={{ textAlign: 'right' }}>
                  <span style={{ fontSize: "8pt" }}>{formatToEuroDateTime(e.erstelltAm)}</span>
                </div>
              </div>
            </div>
          </div>
        ))}

        <p>
          Neue Nachricht:
          <form id='newMessageForm' onSubmit={sendMessage}>
            <input type="text" name="messageText" className='form-control' required={true} placeholder='Neue Nachricht...' value={messageText} onChange={(e) => setMessageText(e.target.value)} maxLength={255} />
            <MaxInputAnzahlComponent max={255} aktuell={messageText.length} />
            <button type="submit" className='btn btn-primary' style={{ marginTop: "10px" }}>Senden</button>
          </form>
        </p>

      </div>
    </>
  );

}

export default AuftragMessageComponent;